import { YOUTUBE_AUTOMATION_STAGE_STATUSES } from './youtubeAutomationStageStatuses'
import { getToggle } from './youtubeSettingsUtils'
import * as youtubeUrls from './youtubeUrls'
import { YoutubeSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { StageType, YoutubeRecommendationKey } from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

// Settings properties
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value === 'true' ? 'On' : 'Off'))

const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => value === 'false')

const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

const notificationLabels = {
  [YoutubeSettingKey.EMAIL_NOTIFICATIONS]:
    'send me emails about my youtube activity and updates i requested',
}

// Stage definitions
enum StageKey {
  GATHER_SETTINGS_EMAIL_NOTIFICATIONS = 'GATHER_SETTINGS_EMAIL_NOTIFICATIONS',
  UPDATE_SETTINGS_EMAIL_NOTIFIATIONS = 'UPDATE_SETTINGS_EMAIL_NOTIFICATIONS',
  UNDO_SETTINGS_EMAIL_NOTIFICATIONS = 'UNDO_SETTINGS_EMAIL_NOTIFICATIONS',
}

const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.GATHER_SETTINGS_EMAIL_NOTIFICATIONS,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: youtubeUrls.notificationsUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      for (const [setting, label] of Object.entries(notificationLabels)) {
        const settingToggle = await getToggle(label)

        await updateStoredInitialValues(
          {
            [setting]: settingToggle.ariaPressed,
          },
          YoutubeRecommendationKey.YOUTUBE_EMAIL_NOTIFICATIONS,
        )
      }
    },
  },
]

const updateStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.UPDATE_SETTINGS_EMAIL_NOTIFIATIONS,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: youtubeUrls.notificationsUrl,
    action: async (machineContext, userContext) => {
      const { isDry, settingsSelected } = userContext

      for (const [setting, label] of Object.entries(notificationLabels)) {
        if (settingsSelected[setting]) {
          const settingToggle = await getToggle(label)

          if (settingToggle.ariaPressed === 'true' && !isDry) {
            settingToggle.click()
          }
        }
      }
    },
  },
]

const undoStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.UPDATE_SETTINGS_EMAIL_NOTIFIATIONS,
    status: YOUTUBE_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: youtubeUrls.notificationsUrl,
    action: async (machineContext, userContext) => {
      const { isDry, initialValues, settingsSelected } = userContext

      for (const [setting, label] of Object.entries(notificationLabels)) {
        if (settingsSelected[setting] && initialValues[setting]) {
          const settingToggle = await getToggle(label)

          if (settingToggle.ariaPressed !== initialValues[setting] && !isDry) {
            settingToggle.click()
          }
        }
      }
    },
  },
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
